var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconHome = function SvgIconHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 57,
    height: 56,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28.5,
    cy: 28,
    r: 28,
    fill: "#EBEEF7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0E1214",
    fillRule: "evenodd",
    d: "M36.9 29.009h-1.5v6.341c0 .144-.124.595-.51 1.039-.361.414-.767.611-1.14.611H31.5v-3a3 3 0 1 0-6 0v3h-2.25c-.328 0-.782-.091-1.109-.32-.24-.167-.541-.487-.541-1.33v-6.341h-1.625c-.082 0-.292-.048-.42-.451-.127-.4-.03-.788.196-1.012l8.525-8.433c.1-.099.18-.113.224-.113.043 0 .124.014.224.113l8.525 8.433c.226.224.323.612.196 1.012-.128.403-.338.45-.42.45zM27 37h3v-3a1.5 1.5 0 0 0-3 0v3m-1.5 1.5h-2.25c-1.05 0-3.15-.525-3.15-3.15v-4.842h-.125c-1.833 0-2.674-2.648-1.279-4.028l8.525-8.433c.737-.73 1.821-.73 2.558 0l8.525 8.433c1.395 1.38.553 4.029-1.28 4.029H36.9v4.841c0 1.197-1.295 3.15-3.15 3.15H25.5",
    clipRule: "evenodd"
  })));
};
export default SvgIconHome;